import { ROLES } from '@/constants/roles';

export default [
  {
    path: '/barcode-pool',
    name: 'barcode_pool_list',
    component: () => import('@/views/pages/barcode-pool/BarcodePoolList.vue'),
    meta: {
      pageTitle: 'Barcode Pool',
      breadcrumb: 'Barcode Pool',
      roles: [ROLES.ADMIN, ROLES.ACCOUNT_ADMIN],
      verticalMenu: {
        title: 'Barcode Pool',
        icon: 'DatabaseIcon'
      }
    }
  },
  {
    path: '/barcode-pool/:id',
    name: 'barcode_pool_detail',
    component: () => import('@/views/pages/barcode-pool/BarcodeRangeDetail.vue'),
    meta: {
      roles: [ROLES.ADMIN, ROLES.ACCOUNT_ADMIN]
    }
  },
  {
    // Legacy URL — keep a redirect so any bookmarked link still lands on
    // the unified detail page (where the barcodes section now lives).
    path: '/barcode-pool/:id/barcodes',
    redirect: to => ({
      name: 'barcode_pool_detail',
      params: { id: to.params.id }
    })
  }
];
